import { assign, EventObject } from 'xstate';
import { ApplyResult } from '../../networkRequests/apply/apply';
import { CustomerSearchResult } from '../../networkRequests/customerSearch/queryCustomersByCellphone';
// TODO use these types below
// import { OrderMachineContext } from '../types/shared/context/orderMachineContext';
// import { ApplyResponseMachineContext } from '../types/shared/context/applyMachineContext';
// import { CustomerSearchResponseMachineContext } from '../types/shared/context/customerSearchMachineContext';

export interface ApplyResponseEvent extends EventObject {
  data?: ApplyResult;
}

export interface CustomerSearchEvent extends EventObject {
  data?: CustomerSearchResult;
}

export const AssignCustomerSearchResult = assign((context: any, event: any) => ({
  accommodationAddress: event.data?.accommodationAddress || context.accommodationAddress,
  application: event.data?.application,
  basicInfo: event.data?.basicInfo || context.basicInfo,
  basicInfoContinued: event.data?.basicInfoContinued || context.basicInfoContinued,
  billingAddress: event.data?.billingAddress || context.billingAddress,
  customerFlowType: event.data?.customerFlowType,
  customers: event.data?.customers,
  customerSearchErrors: event.data?.customerSearchErrors,
  eligibilityDetails: event.data?.eligibilityDetails,
  payFrequency: event.data?.payFrequency || context.payFrequency,
  resolverErrors: event.data?.resolverErrors,
  optedIntoSmsMarketing: event.data.optedIntoSmsMarketing,
}));

export const AssignApplyResult = assign((context: any, event: any) => ({
  application: event.data?.application || context.application,
  customerFlowType: event.data?.customerFlowType || context.customerFlowType,
  applyErrors: event.data?.applyErrors,
  applyResolverErrors: event.data?.applyResolverErrors,
  hardDeclineError: event?.data?.hardDeclineError,
  softDeclineError: event?.data?.softDeclineError,
  cartValidationError: event?.data?.cartValidationError,
}));
